
    <template>
      <section class="content example-md-doc">
        <anchor is-edit label="Layout Settings" fileName="layout-settings.md" />
        <demo-block>
        <div><p>1、Change the layout by setting the <code>layout</code> property.<br>2、The <code>layout</code> property supports the following option items:<br><code>total</code>:Display total number、<code>prev</code>:Show previous button、<code>pager</code>:Show page number button、<code>next</code>:Show next page button、<code>sizer</code>:Show per page size settings、<code>jumper</code>:Show goto input</p>
</div>
        <template slot="source"><element-demo0 /></template>
        <template slot="highlight"><pre v-pre><code class="html">&lt;template&gt;
    &lt;div&gt;
        &lt;div&gt;
            &lt;div class=&quot;mb20 bold&quot;&gt;Don't display page number button&lt;/div&gt;
            &lt;ve-pagination :total=&quot;600&quot; :layout=&quot;['total', 'prev', 'next', 'sizer', 'jumper']&quot; /&gt;
        &lt;/div&gt;
        &lt;div&gt;
            &lt;div class=&quot;mt30 mb20 bold&quot;&gt;Adjust display order&lt;/div&gt;
            &lt;ve-pagination
                :total=&quot;600&quot;
                :layout=&quot;['total', 'sizer', 'prev', 'pager', 'next', 'jumper']&quot;
            /&gt;
        &lt;/div&gt;

        &lt;div&gt;
            &lt;div class=&quot;mt30 mb20 bold&quot;&gt;All layout&lt;/div&gt;
            &lt;ve-pagination
                :total=&quot;600&quot;
                :layout=&quot;['total', 'prev', 'pager', 'next', 'sizer', 'jumper']&quot;
            /&gt;
        &lt;/div&gt;
    &lt;/div&gt;
&lt;/template&gt;
</code></pre></template></demo-block>
      </section>
    </template>
    <script>
        null
      export default {
        name: 'component-doc',
        components: {
          "element-demo0": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('div',[_c('div',[_c('div',{staticClass:"mb20 bold"},[_vm._v("Don't display page number button")]),_vm._v(" "),_c('ve-pagination',{attrs:{"total":600,"layout":['total', 'prev', 'next', 'sizer', 'jumper']}})],1),_vm._v(" "),_c('div',[_c('div',{staticClass:"mt30 mb20 bold"},[_vm._v("Adjust display order")]),_vm._v(" "),_c('ve-pagination',{attrs:{"total":600,"layout":['total', 'sizer', 'prev', 'pager', 'next', 'jumper']}})],1),_vm._v(" "),_c('div',[_c('div',{staticClass:"mt30 mb20 bold"},[_vm._v("All layout")]),_vm._v(" "),_c('ve-pagination',{attrs:{"total":600,"layout":['total', 'prev', 'pager', 'next', 'sizer', 'jumper']}})],1)])]],2)}
var staticRenderFns = []

  
    const democomponentExport = {}
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),
        }
      }
    </script>
    <style lang="less">
      
    </style>
  